// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "loyalty---C_j";
var _4 = "loyalty_aggregator-3S8Co";
var _5 = "loyalty__gainedMiles-2boph";
var _6 = "loyalty__awardedInfo-3WIq3";
var _7 = "loyalty__paper-3rb1P";
export { _1 as "__esModule", _2 as "mobile", _3 as "loyalty", _4 as "loyalty_aggregator", _5 as "loyalty__gainedMiles", _6 as "loyalty__awardedInfo", _7 as "loyalty__paper" }
export default { "__esModule": _1, "mobile": _2, "loyalty": _3, "loyalty_aggregator": _4, "loyalty__gainedMiles": _5, "loyalty__awardedInfo": _6, "loyalty__paper": _7 }
